(function ($) {
    'use strict';

    if (!$) {
        return;
    }

    $(function () {
        $('input[type="submit"]').prop('disabled', false);

        $(document)
            .on('click.bmhPrint', '.print-page-btn', function () {
                window.print();
            })
            .on('focus.bmhMask', '.cnic-mask', function () {
                if ($.fn.inputmask) {
                    $(this).inputmask('99999-9999999-9');
                }
            })
            .on('focus.bmhMask', '.mobile-no-mask', function () {
                if ($.fn.inputmask) {
                    $(this).inputmask('99999999999');
                }
            });

        if ($.fn.select2) {
            $('.select2').select2();
        }

        if ($.fn.DataTable) {
            if ($('.dataTables-1').length && window.loadDataTables) {
                window.loadDataTables();
            }

            if ($('.dataTables-print').length && window.loadDataTablesPrint) {
                window.loadDataTablesPrint();
            }
        }

        $('.form-manual-submit').on('submit.bmhManual', function (event) {
            event.preventDefault();

            if (window.Swal) {
                Swal.fire({
                    title: '',
                    text: 'Please Wait....',
                    imageUrl: '/images/ajax-loader.gif',
                    showCloseButton: false,
                    showCancelButton: false,
                    showConfirmButton: false
                });
            }

            this.submit();
        });

        /*if ($.fn.datetimepicker) {

            $('.datetimepicker').datetimepicker({
                format: 'D-MM-YYYY h\:mm\:ss A'
            });

            $('.datepicker').datetimepicker({
                format: 'D-MM-YYYY'
            });

        }*/
       if ($.fn.datetimepicker) {

            $('.datetimepicker').datetimepicker({
                format: 'D-MM-YYYY h:mm:ss A',
                useCurrent: false
            });

            $('.datepicker').datetimepicker({
                format: 'D-MM-YYYY',
                useCurrent: false
            });

        }
    });
})(window.jQuery);
